import { Checkbox, IconSize, IconWrapper, QuestionmarkCircleIcon, StyledFlex, Tooltip } from '@dreryk/react-components';

import { AppointmentFormController } from '../AppointmentForm.types';
import { appointmentsTranslationKeys } from '../../../../../translations';

export type VideoConsultationValue = boolean;

type VideoConsultationCheckboxProps = Pick<AppointmentFormController, 'register'> & {
   readonly disabled?: boolean;
};

export const VideoConsultationCheckbox = (props: VideoConsultationCheckboxProps): JSX.Element => {
   return (
      <StyledFlex gap={'8px'} alignItems={'center'}>
         <Checkbox
            testId={'videoConsultation'}
            label={appointmentsTranslationKeys.create.form.videoConsultation.label}
            controller={props.register('videoConsultation')}
            disabled={props.disabled}
            defaultValue={false}
         />
         <Tooltip
            testId={'videoConsultation'}
            content={appointmentsTranslationKeys.create.form.videoConsultation.tooltipContent}
         >
            <IconWrapper testId={'toggleTooltipIconWrapper'} size={IconSize.SMALLEST}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </Tooltip>
      </StyledFlex>
   );
};
